import React, { useState } from 'react';
import './CheckInOut.css';

export const RoomButton = ({ rooms }) => {
  const allCount = rooms.length;
  const availableCount = rooms.filter(
    room => room.status === 'available'
  ).length;
  const bookedCount = allCount - availableCount;

  const [activeButton, setActiveButton] = useState(`All rooms(${allCount})`);

  return (
    <div className="button-container">
      <button
        onClick={() => setActiveButton(`All rooms(${allCount})`)}
        className={`button ${
          activeButton === `All rooms(${allCount})` ? 'active' : ''
        }`}
      >
        All rooms({allCount})
      </button>
      <button
        onClick={() => setActiveButton(`Available rooms(${availableCount})`)}
        className={`button ${
          activeButton === `Available rooms(${availableCount})` ? 'active' : ''
        }`}
      >
        Available rooms({availableCount})
      </button>
      <button
        onClick={() => setActiveButton(`Booked(${bookedCount})`)}
        className={`button ${
          activeButton === `Booked(${bookedCount})` ? 'active' : ''
        }`}
      >
        Booked({bookedCount})
      </button>
    </div>
  );
};

export default RoomButton;
